/* @flow strict */

import * as React from 'react';

export const FBpagesTablecolumns = (embed: () => void, uninstall: () => void): [] => {
  return [
    {
      selector: 'name',
      name: 'Page Name',
      sortable: true,
      minWidth: '350px',
      cell: (row: {}): React.Element<'a'> => {
        return (
          <p>
            {row.name}
            {
              row.has_added_app &&
              <span className='checkmark' />
            }
          </p>
        );
      }
      // wrap: true
    },
    {
      selector: 'description',
      name: 'Page Description',
      sortable: true,
      minWidth: '350px'
    },
    {
      selector: '',
      name: '',
      sortable: true,
      // minWidth: '350px',
      textAlign: 'right',
      cell: (row: {}): React.Element<'a'> => {
        return (
          <div style={{ textAlign: 'right', width: '100%' }}>
            {row.has_added_app ?
              <a
                className="btn btn-pink btn-install"
                onClick={(e: any) => {
                  e.preventDefault();
                  uninstall(row);
                }}
              >remove</a>
              :
              <a
                className="btn btn-pink btn-install"
                onClick={(e: any) => {
                  e.preventDefault();
                  embed(row);
                }}
              >embed</a>
            }
          </div>
        );
      }
    }
  ];
};
